import React, { useState } from "react";
import { Button, Input, Modal, Tooltip } from "antd";
import { LinkOutlined } from "@ant-design/icons";
const ShareModal = ({ isOpen, setIsOpen, shareLink }) => {
  const [tooltipText, setTooltipText] = useState("Copy");

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setTooltipText("Copied!");
    setTimeout(() => setTooltipText("Copy"), 2000); 
  };

  return (
    <Modal title="Share" 
    open={isOpen} 
    footer={null} 
    centered
    onOk={() => setIsOpen(false)}
    onCancel={() => setIsOpen(false)}
    width={572}>
      <div style={{ display: "flex", gap: "12px", alignItems: "center"}}>
        <Input value={shareLink} readOnly style={{ background: "#F5F8F5", border:"0", borderRadius:"4px", padding:"10px 16px"}} />
        <Tooltip title={tooltipText}>
          <Button type="primary" icon={<LinkOutlined />} onClick={handleCopy} style={{height:"40px"}}>
          Copy Link
          </Button>
        </Tooltip>
      </div>
    </Modal>
  );
};

export default ShareModal;
